import React, { PropsWithChildren, useReducer } from "react"
import { TopBannerContext } from "./context"
import { initialState, topBannerContextReducer } from "./reducer"

export const TopBannerContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const [state, dispatch] = useReducer(topBannerContextReducer, initialState)

	return <TopBannerContext.Provider value={[state, dispatch]}>{children}</TopBannerContext.Provider>
}
